import { AppDispatchNext, AppGetState } from 'actions/actions.typesNext'
import { fetchSearchSettingsListApi } from 'api/search/fetchSearchSettingsListApi'

export const FETCH_SEARCH_SETTINGS_LIST = 'FETCH_SEARCH_SETTINGS_LIST' as const

export const fetchSearchSettingsListAction = () => ({
  type: FETCH_SEARCH_SETTINGS_LIST,
  promise: fetchSearchSettingsListApi,
})

export const fetchSearchSettingsListIfNeededAction =
  () => (dispatch: AppDispatchNext, getState: AppGetState) => {
    const {
      mainSearchReducer: { searchSettingsLoading },
    } = getState()

    if (searchSettingsLoading) {
      return
    }

    return dispatch(fetchSearchSettingsListAction())
  }
